
// utilitarios
import { Box, CircularProgress, Grid, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useContext, useEffect, useReducer, useState } from "react";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useHistory, useParams } from "react-router-dom";
import { ILiteBot } from '../../types/litebot';
import api from "../../services/api";
import ManagerConexaBot from "../../components/ConexaBot/manager";

const useStyles = makeStyles(() => ({
  modalStyle: {
    padding: "20px 0",
    maxheight: "95vh!important",
    minWidth: "670px",
    background: "#ffffff",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
    "@media (max-width: 740px)": {
      padding: "0px !important",
      marginTop: "65px",
    }
  }
}));

export default function EnhancedTable() {
  const { user } = useContext(AuthContext);
  const classes = useStyles();
  const history = useHistory();

  const { id }: any = useParams();
  const [conexaBot, setConexaBot] = useState<ILiteBot | null>(null);
  const [departments, setDepartments] = useState<any[] | null>(null);
  const [quickReplies, setQuickReplies] = useState<any[] | null>(null);
  const [conclusionMessages, setConclusionMessages] = useState<any[] | null>(null);
  const [openingHours, setOpeningHours] = useState<any[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true)
    if (!id) return;
    // resgatar informações do conexaBot
    (async () => {
      try {
        const { data } = await api.get(`/conexaBot/${id}`);
        if (data) {

          // resgatar os departamentos da conexão do chatbot
          if (data?.connectionId) {
            const { data: dData } = await api.get(`/queue/byConnection/${data.connectionId}`);
            if (Array.isArray(dData) && dData.length > 0) setDepartments(dData);
          }

          // resgatar mensagens rápidas
          if (data?.connectionId) {
            const { data: qData } = await api.get(`/quickAnswers/listAll`);
            if (Array.isArray(qData) && qData.length > 0) setQuickReplies(qData);
          }

          // resgatar mensagens de finalização
          if (data?.connectionId) {
            const { data: cData } = await api.get(`/conclusionMessagesAll`);
            if (Array.isArray(cData?.conclusionMessages) && cData.conclusionMessages.length > 0) setConclusionMessages(cData.conclusionMessages);
          }

          // resgatar horários de atendimento
          if (data?.connectionId) {
            const { data: oData } = await api.get(`/openingHour`);
            if (Array.isArray(oData?.openingHours) && oData.openingHours.length > 0) setOpeningHours(oData.openingHours);
          }

          setConexaBot(data);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      } catch (err: any) {
        setLoading(false)
        console.error('error', err?.response?.data?.message ? i18n.t(err.response.data.message) : i18n.t('generalMessages.INTERNAL_ERROR'));
      }
    })();
  }, [id]);

  return (
    <>
      <Box component="div" className={classes.modalStyle} id="box">

        {
          loading == true
            ?
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginBottom: 2, marginLeft: 20 }}>
                  <Typography variant="h5" style={{ fontWeight: "600" }}>{i18n.t("conexaBots.manager.title")}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 2,
                    height: "calc(100vh - 150px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <CircularProgress size={60} />
                </Grid>
              </Grid>
            </>
            :
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  height: "calc(100vh - 150px)",
                }}
              >
                <ManagerConexaBot
                  id={conexaBot?.id || 0}
                  name={conexaBot?.name || ""}
                  initialEdges={conexaBot?.edges ? JSON.parse(conexaBot.edges) : []}
                  initialNodes={conexaBot?.nodes ? JSON.parse(conexaBot.nodes) : []}
                  initialVariables={conexaBot?.variables ? JSON.parse(conexaBot.variables) : []}
                  departments={departments}
                  quickReplies={quickReplies}
                  conclusionMessages={conclusionMessages}
                  openingHours={openingHours}
                  connection={conexaBot?.Connection || {}}
                />
              </Grid>
            </Grid>
        }

      </Box>
    </>
  );
};